export const PopoverBodyMode = {
  PREVIEW: 'preview',
  EDIT: 'edit'
};
export const PopoverType = {
  INSERT: 'insert',
  EDIT: 'edit'
};
export const KeyTypes = {
  ESCAPE: 'Escape',
  ENTER: 'Enter'
};
export const ColorPickerModes = {
  ADVANCED: 'advanced',
  SIMPLE: 'simple'
};
export const PopoverBodyLiteIcons = {
  EDIT: 'edit',
  REPLACE: 'replace',
  REMOVE: 'delete',
  UNLINK: 'unlink',
  ADD: 'add',
  DELETE: 'minus',
  MERGE: 'merge',
  SPLIT: 'splitModule'
};